#_{:clj-kondo/ignore [:unused-namespace :unused-referred-var]}
(ns manatee.routing.fx
  (:require [bidi.bidi :as bidi]
            [cemerick.url :refer [url]]
            [clojure.string :as str]
            [manatee.routing.app-db :as routes-db]
            [re-frame.core :as rf]
            [utility-belt.uuid :refer [uuid->str]]))

(defn path-for
  [routes & args]
  (apply bidi/path-for
         routes
         (map uuid->str args)))

(rf/reg-cofx
 :path-for
 (fn path-for-cofx
   [{:keys [db] :as coeffects} service-name]
   (if-let [service-routes (routes-db/get-routes db service-name)]
     (assoc coeffects :path-for (partial path-for service-routes))
     (do (prn "Couldn't find routes for service:" service-name)
         coeffects))))

#?(:clj (def current-url (atom nil)))

#_{:clj-kondo/ignore [:unused-binding :unresolved-namespace]}
(defn register-redirect-to
  [init!]
  (rf/reg-fx
   :redirect-to
   (fn [s]
     #?(:clj  (let [path (if (str/starts-with? s "/") s (-> s (url) :path))]
                (init!) ; Init the app as it would happen on full page reload when setting `window.location` in CLJS.
                (kee-frame.api/navigate! @kee-frame.state/navigator path)
                (reset! current-url s))
        :cljs (set! js/window.location s)))))

#_{:clj-kondo/ignore [:unused-binding]}
(rf/reg-fx
 :push-url-history
 (fn [url]
   #?(:cljs (.pushState js/history (or (.-state js/history) #js {}) nil url))))

(rf/reg-cofx
 :current-url
 (fn current-url-cofx
   [coeffects]
   (assoc coeffects :current-url #?(:clj @current-url :cljs js/window.location))))
